import React, { useState, useEffect } from 'react';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/style.css';
import Traveller from './Traveller';
import '../styles/CalendarHeader.css';

export default function CalendarHeader() {
    const [departureDate, setDepartureDate] = useState(new Date());
    const [returnDate, setReturnDate] = useState('');

    const getStartOfToday = () => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return today;
    };

    const getFormattedDate = (date) => {
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const months = [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
        ];

        const dayOfWeek = date.getDay();
        const day = date.getDate();
        const month = date.getMonth();

        return `${days[dayOfWeek]}, ${day} ${months[month]}`;
    };

    const [showDepCalendar, setShowDepCalendar] = useState(false);
    const [showRetCalendar, setShowRetCalendar] = useState(false);

    const handleShowCalendar = (e) => {
        if (e.target.id === 'departure') {
            setShowDepCalendar(true);
            setShowRetCalendar(false);
        } else if (e.target.id === 'return') {
            setShowDepCalendar(false);
            setReturnDate(new Date());
            setShowRetCalendar(true);
        }
        setShowTravel(false);
    };

    const handleHideCalendar = () => {
        setShowDepCalendar(false);
        setShowRetCalendar(false);
    };

    const [from, setFrom] = useState(false);
    const [to, setTo] = useState(false);

    const [fromValue, setFromValue] = useState('');
    const [toValue, setToValue] = useState('');

    const handelInputValue = (e) => {
        if (e.target.id === 'from') {
            setFromValue(e.target.value);
            if (e.target.value.trim()) {
                setFormErrors((prev) => ({ ...prev, from: '' }));
            }
        } else if (e.target.id === 'to') {
            setToValue(e.target.value);
            if (e.target.value.trim()) {
                setFormErrors((prev) => ({ ...prev, to: '' }));
            }
        }
    };

    const handleTextInput = (e) => {
        if (e.target.id === 'from') {
            setFrom(true);
        } else {
            setTo(true);
        }
    };

    const setLabelPosition = (e) => {
        if (e.target.id === 'from') {
            setFrom(false);
        } else {
            setTo(false);
        }
    };

    const [showTravel, setShowTravel] = useState(false);
    const [onChangeData, setOnChangeData] = useState({});
    const [travellerSummary, setTravellerSummary] = useState({
        totalTravellers: 1,
        selectedClass: 'economy',
    });
    const [flightResult, setFlightResult] = useState(null);
    const [formErrors, setFormErrors] = useState({ from: '', to: '' });

    const handleSearch = () => {
        setShowDepCalendar(false);
        setShowRetCalendar(false);
        setShowTravel(false);

        const trimmedFrom = fromValue.trim();
        const trimmedTo = toValue.trim();
        const errors = {
            from: trimmedFrom ? '' : 'Please enter a From location.',
            to: trimmedTo ? '' : 'Please enter a To location.',
        };

        if (errors.from || errors.to) {
            setFormErrors(errors);
            setFlightResult(null);
            return;
        }

        setFormErrors({ from: '', to: '' });
        setFlightResult({
            airline: 'IndiGo',
            flightNumber: '6E-204',
            from: trimmedFrom,
            to: trimmedTo,
            departureDate: getFormattedDate(departureDate),
            returnDate: returnDate ? getFormattedDate(returnDate) : null,
            departureTime: '08:30 AM',
            arrivalTime: '10:45 AM',
            duration: '2h 15m',
            travellers: travellerSummary.totalTravellers,
            travelClass: travellerSummary.selectedClass,
            price: '$485',
            status: 'Available',
        });
    };

    const handleTravellerSummaryUpdate = (data) => {
        setTravellerSummary(data);
        setOnChangeData(data);
    };

    const handleShowTraveller = () => {
        setShowTravel(true);
        setShowRetCalendar(false);
        setShowDepCalendar(false);
    };

    useEffect(() => {
        setShowTravel(false);
    }, [onChangeData]);

    return (
        <header>
            <div className="all-input-container">
                <div className="form-row location-row">
                    <div className="input-fields-container text-input">
                        <label htmlFor="from" className={`label from-label ${from || fromValue ? 'active' : ''}`}>
                            From <span className="required-mark">*</span>
                        </label>
                        <input
                            type="text"
                            id="from"
                            name="from"
                            value={fromValue}
                            onChange={handelInputValue}
                            onFocus={handleTextInput}
                            onBlur={setLabelPosition}
                            required
                            aria-required="true"
                            aria-invalid={formErrors.from ? 'true' : 'false'}
                        />
                        {formErrors.from && (
                            <p className="field-error" id="from-error" role="alert">
                                {formErrors.from}
                            </p>
                        )}
                    </div>
                    <div className="arrow-container">
                        <i className="bx bx-transfer-alt"></i>
                    </div>
                    <div className="input-fields-container text-input">
                        <label htmlFor="to" className={`label to-label ${to || toValue ? 'active' : ''}`}>
                            To <span className="required-mark">*</span>
                        </label>
                        <input
                            type="text"
                            id="to"
                            name="to"
                            value={toValue}
                            onChange={handelInputValue}
                            onFocus={handleTextInput}
                            onBlur={setLabelPosition}
                            required
                            aria-required="true"
                            aria-invalid={formErrors.to ? 'true' : 'false'}
                        />
                        {formErrors.to && (
                            <p className="field-error" id="to-error" role="alert">
                                {formErrors.to}
                            </p>
                        )}
                    </div>
                </div>

                <div className="form-row dates-row">
                    <div className="input-fields-container dep-date-input">
                        <label htmlFor="departure" className="label dep-label">Departure</label>
                        <input
                            type="text"
                            id="departure"
                            onFocus={handleShowCalendar}
                            value={getFormattedDate(departureDate)}
                            readOnly
                        />
                    </div>
                    <div className="input-fields-container ret-date-input">
                        <label htmlFor="return" className={`label return-label ${showRetCalendar || returnDate ? 'active' : ''}`}>Return</label>
                        <input
                            type="text"
                            id="return"
                            onFocus={handleShowCalendar}
                            value={`${showRetCalendar || returnDate ? getFormattedDate(returnDate) : ''}`}
                            readOnly
                        />
                        {showRetCalendar || returnDate ? (
                            <span
                                className="cross"
                                onClick={() => {
                                    setShowRetCalendar(false);
                                    setReturnDate('');
                                }}
                            >
                                &#10006;
                            </span>
                        ) : null}
                    </div>
                </div>

                <div className="form-row action-row">
                    <div className="traveller-container input-fields-container">
                        <label htmlFor="traveller" className="label dep-label">Travelers & class</label>
                        <input
                            type="text"
                            id="traveller"
                            onFocus={handleShowTraveller}
                            readOnly
                            value={`${travellerSummary.totalTravellers} Traveller, ${travellerSummary.selectedClass}`}
                        />
                    </div>
                    <button type="button" id="search-btn" className="search-btn" onClick={handleSearch}>
                        Search
                    </button>
                </div>
            </div>

            {flightResult && (
                <div className="flight-results" id="flight-results">
                    <h3 className="flight-results-title">Available Flights</h3>
                    <div className="flight-card" id="flight-card">
                        <div className="flight-card-header">
                            <span className="flight-airline" id="flight-airline">
                                {flightResult.airline}
                            </span>
                            <span className="flight-number" id="flight-number">
                                {flightResult.flightNumber}
                            </span>
                            <span className="flight-status" id="flight-status">
                                {flightResult.status}
                            </span>
                        </div>
                        <div className="flight-route">
                            <div className="flight-route-point">
                                <span className="flight-city" id="flight-from">{flightResult.from}</span>
                                <span className="flight-time" id="flight-departure-time">
                                    {flightResult.departureTime}
                                </span>
                            </div>
                            <div className="flight-route-line">
                                <span className="flight-duration" id="flight-duration">
                                    {flightResult.duration}
                                </span>
                            </div>
                            <div className="flight-route-point">
                                <span className="flight-city" id="flight-to">{flightResult.to}</span>
                                <span className="flight-time" id="flight-arrival-time">
                                    {flightResult.arrivalTime}
                                </span>
                            </div>
                        </div>
                        <div className="flight-card-footer">
                            <span className="flight-date" id="flight-departure-date">
                                Departure: {flightResult.departureDate}
                            </span>
                            {flightResult.returnDate && (
                                <span className="flight-date" id="flight-return-date">
                                    Return: {flightResult.returnDate}
                                </span>
                            )}
                            <span className="flight-travellers" id="flight-travellers">
                                {flightResult.travellers} Traveller, {flightResult.travelClass}
                            </span>
                            <span className="flight-price" id="flight-price">{flightResult.price}</span>
                        </div>
                    </div>
                </div>
            )}
            <div className="calendar-wrapper">
                {showDepCalendar && (
                    <div className="calendar-container calendar-container--departure">
                        <button
                            type="button"
                            className="calendar-close-btn"
                            onClick={handleHideCalendar}
                            aria-label="Close calendar"
                        >
                            ×
                        </button>
                        <DayPicker
                            mode="single"
                            selected={departureDate}
                            onSelect={(date) => {
                                if (date) setDepartureDate(date);
                                handleHideCalendar();
                            }}
                            disabled={{ before: getStartOfToday() }}
                            className="calendar"
                        />
                    </div>
                )}
                {showRetCalendar && (
                    <div className="ret-calendar-container calendar-container--return">
                        <button
                            type="button"
                            className="calendar-close-btn"
                            onClick={handleHideCalendar}
                            aria-label="Close calendar"
                        >
                            ×
                        </button>
                        <DayPicker
                            mode="single"
                            selected={returnDate}
                            onSelect={(date) => {
                                if (date) setReturnDate(date);
                                handleHideCalendar();
                            }}
                            disabled={{ before: getStartOfToday() }}
                            className="calendar"
                        />
                    </div>
                )}
                {showTravel && <Traveller onTravellerSummaryUpdate={handleTravellerSummaryUpdate} />}
            </div>
        </header>
    );
}
